























































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { hasAuth } from '@/utils/validate';
import { D_BRAND_AUTH, D_ORG_INFO } from '@/menu/auth-const';
import { initPageParams } from '@/utils/constants';
import { IActions as A1 } from '@/store/brand-audit/auth/types';
import { IActions as A2 } from '@/store/brand-audit/apply/types';
import OffsetCard from '@/components/widget/OffsetCard.vue';
import OrgInfo from './info/OrgInfo.vue';
import BrandAuthList from './auth/BrandAuthList.vue';
import BrandAuthApply from './apply/BrandAuthApply.vue';
import BrandAuthApplyLogs from './apply/BrandAuthApplyLogs.vue';
import BrandAuthAudit from './audit/BrandAuthAudit.vue';
import BrandAuthAuditLogs from './audit/BrandAuthAuditLogs.vue';

const Auth = namespace('brandAudit/auth');
const Apply = namespace('brandAudit/apply');

@Component({
  components: { 
    OffsetCard, OrgInfo, BrandAuthList, BrandAuthAudit, BrandAuthAuditLogs,
    BrandAuthApply, BrandAuthApplyLogs, 
  },
})
export default class BrandAuthIndex extends Vue {
  @Auth.Action('queryAuthBrandPage') public queryAuthedBrandPage!: A1['queryAuthBrandPage'];
  @Apply.Action('queryMyApplications') public queryApplications!: A2['queryMyApplications'];
  @Apply.Action('queryMyAudits') public queryAudits!: A2['queryMyAudits'];
  @Auth.State('hasOwnerBrand') public hasOnwerBrand!: boolean;

  public tabIndex = 0;
  public hasBrandAuth = hasAuth([D_BRAND_AUTH]);  // 是否拥有'品牌授权管理'权限
  public hasOrgInfoAuth = hasAuth([D_ORG_INFO]);  // 是否拥有'企业信息管理'权限

  // 是否显示审核模块
  public get showAudit() {
    return this.hasBrandAuth && this.hasOnwerBrand;
  }

  public gotoApplyAdd() {
    this.$router.push({ name: 'enterprise-brand-auth-apply' });
  }

  // 刷新授权列表
  public onRefreshAuth() {
    this.queryAuthedBrandPage(initPageParams);
  }

  // 刷新申请列表
  public onRefreshApplications() {
    this.queryApplications();
  }

  // 刷新审核列表
  public onRefreshAudits() {
    this.queryAudits();
  }
}
